<template>
    <div>
        <div class="p-grid">
            <app-menu-bar
                title="Daftar Dokumen Pengadaan"
                back_url="dokumen_pengadaan.dashboard"
            />
            <div class="p-col-12">
                <div class="card">
                    <DataTable
                        ref="dt"
                        :value="datatable.data"
                        :lazy="true"
                        data-key="id"
                        :paginator="true"
                        :rows="10"
                        :loading="datatable.loading"
                        :total-records="datatable.totalRecords"
                        filter-display="menu"
                        :global-filter-fields="datatable.globalFilterFields"
                        v-model:filters="datatable.filters"
                        paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rows-per-page-options="[5, 10, 25]"
                        current-page-report-template="Menampilkan data ke {first} sampai {last} dari total {totalRecords} data"
                        @page="onPage($event)"
                        @sort="onSort($event)"
                        @filter="onFilter()"
                    >
                        <template #header>
                            <div class="table-header">
                                <div class="flex justify-content-between">
                                    <Button
                                        type="button"
                                        icon="pi pi-filter-slash"
                                        label="Clear"
                                        class="p-button-outlined"
                                        @click="clearFilter()"
                                    />
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText
                                            v-model="
                                                datatable.filters['global']
                                                    .value
                                            "
                                            @keydown.enter="onFilter()"
                                            placeholder="Keyword Search"
                                        />
                                    </span>
                                </div>
                            </div>
                        </template>
                        <Column field="isi_doc" header="Keterangan Dokumen">
                            <template #body="slotProps">
                                {{ slotProps.data.isi_doc }}
                            </template>
                        </Column>
                        <Column header="Aksi" style="width: 150px">
                            <template #body="slotProps">
                                <Button
                                    icon="pi pi-check-square"
                                    label="Penawaran"
                                    class="p-button-info p-button-sm mr-1"
                                    @click="penawaran(slotProps.data)"
                                />
                            </template>
                        </Column>
                        <template #empty> Belum ada Data! </template>
                    </DataTable>
                </div>
            </div>
        </div>

        <Dialog
            header="Penawaran"
            v-model:visible="displayModalPenawaran"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ width: '70vw' }"
            :maximizable="true"
            :modal="true"
        >
            <div v-if="loadingModalPenawaran">
                <ProgressBar
                    mode="indeterminate"
                    v-if="loadingModalPenawaran"
                />
            </div>
            <div v-else>
                <PenawaranPage
                    v-on:closemodal="closeModal()"
                    :dataViewDokumenPengadaan="this.penawaran_form_data"
                    :uuid="this.penawaran_form_data.uuid"
                    :errors="[]"
                />
            </div>
        </Dialog>

        <DeleteDialog
            ref="deleteDialog"
            v-model:visible="deleteDialog"
            :loading="deletingModel"
            @delete="onDelete"
        />
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "../../Layouts/AppLayout";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import Menubar from "primevue/menubar";
import ProgressBar from "primevue/progressbar";
import Column from "primevue/column";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import DeleteDialog from "../../Components/DeleteDialog";
import PenawaranPage from "./PenawaranPage.vue";
import Toolbar from "primevue/toolbar";
import { Link } from "@inertiajs/inertia-vue3";
import qs from "qs";
import _ from "lodash";

import { stringify, parse } from "flatted";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        AppLayout,
        AppMenuBar,
        Menubar,
        DataTable,
        Column,
        Button,
        DeleteDialog,
        Toolbar,
        Link,
        InputText,
        Dialog,
        ProgressBar,
        PenawaranPage,
    },
    props: {
        prosedur_id: String,
        kode_tahap: String,
        status: String,
    },
    data() {
        return {
            form_data: null,
            displayModalPenawaran: false,
            loadingModalPenawaran: false,
            penawaran_form_data: null,
            datatable: {
                prosedur_id: this.prosedur_id,
                kode_tahap: this.kode_tahap,
                status: this.status,
                loading: true,
                totalRecords: 0,
                data: null,
                globalFilterFields: ["isi_doc"],
                filters: {
                    global: {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS,
                    },
                    // 'status': {value: null, matchMode: FilterMatchMode.EQUALS},
                },
                lazyParams: {},
            },
            menuItems: [
                {
                    label: "Tambah User",
                    icon: "pi pi-fw pi-plus",
                    class: "p-button-primary p-button-raised",
                    command: () => {
                        this.$inertia.get(this.route("users.create"));
                    },
                },
            ],
            importDialog: false,
            importForm: this.$inertia.form({
                file: null,
            }),
            selectedModel: null,
            deleteDialog: false,
            deletingModel: false,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
    },
    async mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            prosedur_id: this.prosedur_id,
            kode_tahap: this.kode_tahap,
            status: this.status,
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.datatable.filters,
            globalFilterFields: this.datatable.globalFilterFields,
        };
        this.loadLazyData();
    },
    methods: {
        async loadLazyData() {
            this.datatable.loading = true;

            try {
                const res = axios.get(
                    route(
                        `/dokumen_pengadaan/datatable_list_available_penyedia/`
                    ),
                    {
                        params: {
                            prosedur_id: this.prosedur_id,
                            kode_tahap: this.kode_tahap,
                            status: this.status,
                            dt_params: JSON.stringify(
                                this.datatable.lazyParams
                            ),
                            searchable_columns: JSON.stringify(
                                this.datatable.globalFilterFields
                            ),
                        },
                    }
                );

                this.datatable.data = res.data.payload.data;
                this.datatable.totalRecords = res.data.payload.total;
                this.datatable.loading = false;
            } catch (e) {
                this.datatable.loading = false;

                this.datatable.data = [];
                this.datatable.totalRecords = 0;
                // loading.value = false;
            }
            this.datatable.loading = true;
            this.datatableService
                .getData(
                    this.route(
                        "dokumen_pengadaan.datatable_list_available_penyedia"
                    ),
                    {
                        dt_params: JSON.stringify(this.datatable.lazyParams),
                        searchable_columns: JSON.stringify(
                            this.datatable.globalFilterFields
                        ),
                    }
                )
                .then((data) => {
                    this.datatable.data = data.payload.data;
                    // console.log('DATA is ready');
                    this.datatable.totalRecords = data.payload.total;
                    this.datatable.loading = false;
                });
        },
        onFilter() {
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
            // this.datatable.lazyParams.filters = this.datatable.filters;
            // console.log('huehue');
            // this.loadLazyData();
        },
        clearFilter() {
            this.datatable.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                // 'status': {value: null, matchMode: FilterMatchMode.EQUALS},
            };

            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
        },
        onPage(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // console.log(this.datatable.lazyParams);
            // this.loadLazyData();
        },
        onSort(event) {
            // console.log(event);
            this.datatable.lazyParams = event;
            this.loadLazyData();
            // this.datatable.lazyParams = {
            //     globalFilterFields : this.datatable.lazyParams.globalFilterFields,
            //     ...event
            // };
            // this.loadLazyData();
        },
        penawaran(data) {
            this.penawaran_form_data = null;
            this.loadingModalPenawaran = true;
            this.displayModalPenawaran = true;
            axios
                .get(route("dokumen_pengadaan.get_detail_dokumen_pengadaan"), {
                    params: {
                        uuid: data.uuid,
                    },
                })
                .then((res) => {
                    this.penawaran_form_data = res.data.data;
                    this.penawaran_form_data.uuid = data.uuid;
                    this.loadingModalPenawaran = false;
                });
        },
        closeModal() {
            this.displayModalPenawaran = false;
            this.loadLazyData();
        },
    },
};
</script>

<style scoped></style>
